import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'services/auth/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
	constructor(private router: Router, private authService: AuthService) {}

	canActivate(route, state: RouterStateSnapshot) {
		if (this.authService.readAccess) return true;
		this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
		return false;
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/services/auth/auth-guard.service.ts